import { queryOptions } from '@tanstack/react-query';
import { UserService } from '@/features/auth/services/UserService.ts';

export const userQueryKeys = {
  all: ['users'],
  current: () => [...userQueryKeys.all, 'current'],
};

export const userQueries = {
  getCurrentUser: () =>
    queryOptions({
      queryKey: userQueryKeys.current(),
      queryFn: UserService.getCurrentUser,
    }),
};
